import React, {useCallback, useEffect, useRef, useState} from "react";
import {getAllElapsedTime, searchDistinctMethod, searchDistinctModule, searchElapsedTime} from "../../api/ProfilingAPI";
import {Button, Input, Option, Select} from "@material-tailwind/react";
import Spinner from "../../components/Progress/Spinner";
import ElapsedHelper from "../../components/Collapse/ElapsedHelper";

export default function Elapsed() {
  const LOCAL = "local"
  const DEV = "dev"
  const STG = "stg"

  const DEVICE_ID = "deviceId"
  const TASK_ID = "taskId"
  const MODULE = "module"
  const METHOD = "method"
  const ROUND = "round"
  const START_TIME = "startTime"
  const END_TIME = "endTime"
  const ELAPSED_TIME = "elapsedTime"
  const RESULT = "result"
  const CONFIG = "config"


  const [elapsed, setElapsed] = useState([]);
  const [search, setSearch] = useState({
    [DEVICE_ID]: "",
    [TASK_ID]: "",
    [MODULE]: "",
    [METHOD]: "",
    [ROUND]: "",
    [ELAPSED_TIME]: ""
  });
  const [selectServer, setSelectServer] = useState(LOCAL)

  let page = 0
  const PAGE_SIZE = 50
  const observer = useRef()
  const [hasMoreData, setHasMoreData] = useState(false)

  const [moduleLoading, setModuleLoading] = useState(false)
  const [moduleList, setModuleList] = useState([])
  const [methodLoading, setMethodLoading] = useState(false)
  const [methodList, setMethodList] = useState([])

  useEffect(() => {
    setModuleLoading(true)
    searchDistinctModule(selectServer)
      .then(res => res.json())
      .then(res => {
        setModuleList(res["data"])
      })
      .catch(err => console.log(err))
      .finally(() => setModuleLoading(false))
  }, [selectServer]);

  useEffect(() => {
    setMethodLoading(true)
    searchDistinctMethod(selectServer)
      .then(res => res.json())
      .then(res => {
        setMethodList(res["data"])
      })
      .catch(err => console.log(err))
      .finally(() => setMethodLoading(false))
  }, [selectServer]);

  const handleSelectServer = (e) => {
    setSelectServer(e)
  }

  const handleSelectModule = (e) => {
    if (e === "All") {
      e = ""
    }

    setSearch({
      ...search,
      [MODULE]: e
    })
  }

  const handleSelectMethod = (e) => {
    if (e === "All") {
      e = ""
    }

    setSearch({
      ...search,
      [METHOD]: e
    })
  }

  const handleSearchText = (e, field) => {
    setSearch({
      ...search,
      [field]: e.target.value
    })
  }

  const requestSearchElapsedTime = () => {
    searchElapsedTime(selectServer, search, page, PAGE_SIZE)
      .then(res => res.json())
      .then(res => {
        if (res['data'].length === 0) {
          setHasMoreData(false)
        } else {
          setHasMoreData(true)
          setElapsed(prev => [...prev, ...res['data']])
          page++;
        }
      })
      .catch(err => console.log(err))
  }

  const clearState = () => {
    setElapsed([])
    setHasMoreData(false)
    page = 0
  }

  const onCheckEnter = (e) => {
    if (e.key === "Enter") {
      clearState()
      requestSearchElapsedTime()
    }
  }

  const handleSearch = (e) => {
    e.preventDefault()
    clearState()
    requestSearchElapsedTime()
  }

  const handleClear = () => {
    clearState()
  }

  const handleFullSearch = () => {
    clearState()
    getAllElapsedTime(selectServer)
      .then(res => res.json())
      .then(res => {
        setElapsed(res['data'])
        setHasMoreData(false)
      })
      .catch(err => console.log(err))
  }

  const lastElementRef = useCallback((node) => {
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        requestSearchElapsedTime()
      }
    });
    if (node) observer.current.observe(node);
    //eslint-disable-next-line
  }, [search])

  return (
    <>
      <div className="flex flex-col h-[80vh]">
        <div className="flex-grow overflow-auto">
          <div className="flex justify-end">
            <div className="m-5 w-72">
              <Select onChange={handleSelectServer} value={LOCAL} label="Select Version">
                <Option value={LOCAL}>Local</Option>
                <Option value={DEV}>Dev</Option>
                <Option value={STG}>Stg</Option>
              </Select>
            </div>
          </div>
          <div className="rounded border-solid border-2">
            <form className="m-4">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                <div>
                  <Input label="Task ID"
                         onChange={e => handleSearchText(e, TASK_ID)}
                         onKeyPress={onCheckEnter}
                  />
                </div>
                <div>
                  <Input label="Device ID"
                         onChange={e => handleSearchText(e, DEVICE_ID)}
                         onKeyPress={onCheckEnter}
                  />
                </div>
                <div>
                  <Select onChange={handleSelectModule} label="Select module" disabled={moduleLoading}>
                    {
                      ["All", ...moduleList].map((item) => {
                        return <Option key={item} value={item}>{item}</Option>
                      })
                    }
                  </Select>
                </div>
                <div>
                  <Select onChange={handleSelectMethod} label="Select method" disabled={methodLoading}>
                    {
                      ["All", ...methodList].map((item) => {
                        return <Option key={item} value={item}>{item}</Option>
                      })
                    }
                  </Select>
                </div>
                <div>
                  <Input label="Round"
                         onChange={e => handleSearchText(e, ROUND)}
                         onKeyPress={onCheckEnter}
                  />
                </div>
                <div>
                  <Input label="Over Elapsed Time"
                         onChange={e => handleSearchText(e, ELAPSED_TIME)}
                         onKeyPress={onCheckEnter}
                  />
                </div>
              </div>
            </form>
            <div className="flex justify-center">
              <div className="m-2">
                <Button color="blue" onClick={handleSearch}>
                  Search
                </Button>
              </div>
              <div className="m-2">
                <Button color="blue" onClick={handleClear}>
                  Clear
                </Button>
              </div>
              <div className="m-2">
                <Button color="red" className="w-30" onClick={handleFullSearch}>
                  Full Search
                </Button>
              </div>
              <div className="m-2">
                <ElapsedHelper/>
              </div>
            </div>
          </div>

          <div className="rounded relative">
            <div className="flex w-full font-bold pb-3 sticky top-0 py-3 bg-orange-300">
              <div className="text-center w-1/12">
                <p>Device ID</p>
              </div>
              <div className="inline-block w-0.5 bg-neutral-100 opacity-100 dark:opacity-50"></div>
              <div className="text-center w-1/12">
                <p>Task ID</p>
              </div>

              <div className="inline-block w-0.5 bg-neutral-100 opacity-100 dark:opacity-50"></div>
              <div className="text-center w-1/12">
                <p>Module</p>
              </div>

              <div className="inline-block w-0.5 bg-neutral-100 opacity-100 dark:opacity-50"></div>
              <div className="text-center w-1/12">
                <p>Method</p>
              </div>

              <div className="inline-block w-0.5 bg-neutral-100 opacity-100 dark:opacity-50"></div>
              <div className="text-center w-1/12">
                <p>Round</p>
              </div>

              <div className="inline-block w-0.5 bg-neutral-100 opacity-100 dark:opacity-50"></div>
              <div className="text-center w-1/12">
                <p>Start Time</p>
              </div>

              <div className="inline-block w-0.5 bg-neutral-100 opacity-100 dark:opacity-50"></div>
              <div className="text-center w-1/12">
                <p>End Time</p>
              </div>

              <div className="inline-block w-0.5 bg-neutral-100 opacity-100 dark:opacity-50"></div>
              <div className="text-center w-1/12">
                <p>Elapsed Time</p>
              </div>

              <div className="inline-block w-0.5 bg-neutral-100 opacity-100 dark:opacity-50"></div>
              <div className="text-center w-2/12">
                <p>Result Log</p>
              </div>

              <div className="inline-block w-0.5 bg-neutral-100 opacity-100 dark:opacity-50"></div>
              <div className="text-center w-2/12">
                <p>Config</p>
              </div>
            </div>

            {
              elapsed
                .map((item, idx) => {
                  return <div key={idx}>
                    <hr className="h-0.5 border-t-0 bg-neutral-100 opacity-100 dark:opacity-50"/>
                    <div className="flex w-full text-sm text-center">
                      <div className="w-1/12 p-1">
                        {item[DEVICE_ID]}
                      </div>
                      <div className="w-1/12 p-1">
                        {item[TASK_ID]}
                      </div>
                      <div className="w-1/12 p-1">
                        {item[MODULE]}
                      </div>
                      <div className="w-1/12 p-1">
                        {item[METHOD]}
                      </div>
                      <div className="w-1/12 p-1">
                        {item[ROUND]}
                      </div>
                      <div className="w-1/12 p-1">
                        {item[START_TIME]}
                      </div>
                      <div className="w-1/12 p-1">
                        {item[END_TIME]}
                      </div>
                      <div className="w-1/12 p-1">
                        {item[ELAPSED_TIME]}
                      </div>
                      <div className="w-2/12 p-1 overflow-y-auto h-24">
                        {item[RESULT]}
                      </div>
                      <div className="w-2/12 p-1 overflow-y-auto h-24">
                        {JSON.stringify(item[CONFIG])}
                      </div>

                      {
                        elapsed.length === idx + 1 &&
                        hasMoreData &&
                        <div ref={lastElementRef}/>
                      }
                    </div>
                  </div>
                })
            }

            {
              hasMoreData &&
              <Spinner/>
            }
          </div>
        </div>
      </div>
    </>
  );
}
